import React from 'react'

const UserName = ({ firstName = '', lastName = '' }) => (
    <div className='font-bold text-lg mt-2'>
        {firstName} {lastName}
    </div>
)

export default UserName
